import { Box, Chip, Divider, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import React from 'react'

function formatLayoverDuration (minutes: number): string {
    const hours = Math.floor(minutes / 60)
    const mins = minutes % 60

    if (hours > 0) {
        return `${hours}h ${mins}m`
    } else {
        return `${mins}m`
    }
}

const ChangeFlights: React.FC<{
    layOverDuration?: number | undefined
    layoverAirport: string | undefined
    transitVisa?: boolean
}> = ({ layOverDuration, layoverAirport, transitVisa }) => {
    const layOver = formatLayoverDuration(layOverDuration ? layOverDuration : 0)
    const t = useTranslations('common')
    return (
        <Divider sx={{ my: 0.5, position: 'relative', pb: 2 }}>
            <Chip
                onClick={e => e.stopPropagation()}
                label={
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography variant="caption" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                                {t('changeOfFlights')}
                            </Typography>
                            <Typography variant="caption">•</Typography>
                            <Typography variant="caption" fontWeight="bold">
                                {layOver} {t('layover')} {t('in')} {layoverAirport}
                            </Typography>
                        </Box>
                        {transitVisa && (
                            <Typography variant="caption" fontWeight="bold">
                                {t('transitVisaMayBeRequired')}
                            </Typography>
                        )}
                    </Box>
                }
                size="small"
                sx={{
                    height: 'auto',
                    px: '10px',
                    py: '4px',
                    backgroundColor: 'white',
                    border: '1px solid #e0e0e0',
                    fontSize: '11px',
                    '&:hover': {
                        backgroundColor: 'white'
                    }
                }}
            />
        </Divider>
    )
}

export default ChangeFlights
